import { render } from "./toDoList.vue?vue&type=template&id=35ab46a4&scoped=true"
import script from "./toDoList.vue?vue&type=script&lang=js"
export * from "./toDoList.vue?vue&type=script&lang=js"

import "./toDoList.vue?vue&type=style&index=0&id=35ab46a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ab46a4"]])

export default __exports__